import React, { FormEvent, useState } from "react";
import { DropdownComponent, InputComponent } from "../../components/core/Forms";
import { useReportStore } from "../../state/useReportStore";
import { REPORT_LIST, CUSTOMER_LIST } from "../../constants";
import { Reports } from "../../constants/Report";
import CustomerReportFilterForm from "../../components/Report/customerReportFilterForm";
import ExpenseReportFilterForm from "../../components/Report/expenseReportFilterForm";
import InvoiceReportFilterForm from "../../components/Report/invoiceReportFilterForm/index";
import InventoryFilterForm from "./InventoryReportFilterForm";
import useDownloadReport from "../../hooks/useDownloadReport";
import { getInvoiceReport } from "../../backend-services";
import ProfitLossReportFilterForm from "./profitLossReportFlterForm";
import { ItemInput } from "../../@types";
import { Tooltip } from "../../assets/icons/Tooltip";
import { getYesterdayDate } from "../../utils/duration";
import useDownloadCsvReport from "../../hooks/UseDownloadCsvReport";
import { useTranslation } from "react-i18next";

const defaultItem: ItemInput = {
  id: "",
  name: "",
};

interface FormData {
  vendorId?: string;
  customerId?: string;
  startDate: string;
  endDate: string;
  status?: string;
  paymentMethod?: string;
}

const ReportForm = () => {
  const { t } = useTranslation("report");
  const [reportValue, setReportValue] = useState(t("report.selectType"));
  const [text, setText] = React.useState("");
  const [formData, setFormData] = useState<FormData>({
    vendorId: "",
    customerId: "",
    startDate: new Date().toISOString().substring(0, 10),
    endDate: "",
    status: "",
    paymentMethod: "",
  });

  const dropdownArray = REPORT_LIST;
  const [item, setItem] = useState<ItemInput>(defaultItem);
  const [serviceName, SetServiceName] = React.useState("");

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      return { ...prevFormData, [name]: value };
    });
  };

  const yesterdayDate = getYesterdayDate();
  const handleUpdate = (updatedReport: any) => {};

  const { downloadPDF, isLoadingPDF } = useDownloadReport({
    type:
      reportValue === Reports.INVOICE_REPORT
        ? Reports.INVOICE_REPORT
        : reportValue === Reports.EXPENSE_REPORT
        ? Reports.EXPENSE_REPORT
        : reportValue === Reports.CUSTOMER_REPORT
        ? Reports.CUSTOMER_REPORT
        : reportValue === Reports.INVENTORY_REPORT
        ? Reports.INVENTORY_REPORT
        : reportValue === Reports.PROFITLOSS_REPORT
        ? Reports.PROFITLOSS_REPORT
        : "",
    startDate: formData.startDate,
    endDate: formData.endDate,
    customerId: formData.customerId,
    status: formData.status,
    vendorId: formData.vendorId,

    paymentMethod: formData.paymentMethod,
    onUpdate: handleUpdate,
  });
  const { downloadCSV, isLoadingCSV } = useDownloadCsvReport({
    type:
      reportValue === Reports.INVOICE_REPORT
        ? Reports.INVOICE_REPORT
        : reportValue === Reports.EXPENSE_REPORT
        ? Reports.EXPENSE_REPORT
        : reportValue === Reports.CUSTOMER_REPORT
        ? Reports.CUSTOMER_REPORT
        : reportValue === Reports.INVENTORY_REPORT
        ? Reports.INVENTORY_REPORT
        : reportValue === Reports.PROFITLOSS_REPORT
        ? Reports.PROFITLOSS_REPORT
        : "",
    startDate: formData.startDate,
    endDate: formData.endDate,
    customerId: formData.customerId,
    status: formData.status,
    vendorId: formData.vendorId,

    paymentMethod: formData.paymentMethod,
    onUpdate: handleUpdate,
  });

  const handleSubmitPDF = async (e: any) => {
    e.preventDefault();
    await downloadPDF();
  };

  const handleSubmitCSV = async (e: any) => {
    e.preventDefault();
    await downloadCSV();
  };

  const handleInfo = (name: string, value: string) => {
    if (value === Reports.EXPENSE_REPORT) {
      SetServiceName(t("report.expense"));
      return;
    }
    if (value === Reports.EXPENSE_REPORT_CSV) {
      SetServiceName("Expense's Report Csv");
      return;
    }
    if (value === Reports.CUSTOMER_REPORT) {
      SetServiceName(t("report.customer"));
      return;
    }
    if (value === Reports.CUSTOMER_REPORT_CSV) {
      SetServiceName("Customer's Report Csv");
      return;
    }
    if (value === Reports.INVENTORY_REPORT) {
      SetServiceName(t("report.inventory"));
      return;
    }
    if (value === Reports.INVENTORY_REPORT_CSV) {
      SetServiceName("Inventory's Report");
      return;
    }
    if (value === Reports.INVOICE_REPORT) {
      SetServiceName(t("report.invoice"));
      return;
    }
    if (value === Reports.INVOICE_REPORT_CSV) {
      SetServiceName("Invoice-Report-csv");
      return;
    }
    if (value === Reports.PROFITLOSS_REPORT) {
      SetServiceName("Profit and Loss' Report");
      return;
    }
    if (value === Reports.PROFITLOSS_REPORT_CSV) {
      SetServiceName("Profit and Loss' Report");
      return;
    }
  };

  return (
    <div className="relative flex flex-col w-full md:max-w-[500px] md:items-center md:justify-normal md:pl-[0px] lg:pl-[0px] pt-[28px]">
      <form className="w-full">
        <div className="w-full">
          <label className="w-full">{t("report.type")}</label>
          <div className="w-full">
            <DropdownComponent
              options={dropdownArray}
              value={reportValue}
              selectedValue={reportValue}
              setSelectedValue={setReportValue}
              onChange={handleInfo}
              dropdownClassName=" w-full cursor-pointer border-[#D0D5DD]"
              iconClassName="320:mr-0 mr-[-2em] mt-[0.2em] md:mt-0 sm:mr-[7em] md:mr-[-2em]"
              className="w-full"
            />
          </div>
        </div>
        {reportValue === Reports.EXPENSE_REPORT && (
          <>
            <ExpenseReportFilterForm
              formData={formData}
              setFormData={setFormData}
              handleOnChange={handleChange}
            />
          </>
        )}
        {reportValue === Reports.INVOICE_REPORT && (
          <>
            <InvoiceReportFilterForm
              formData={formData}
              setFormData={setFormData}
              handleOnChange={handleChange}
            />
          </>
        )}
        {reportValue === Reports.CUSTOMER_REPORT && (
          <>
            <CustomerReportFilterForm
              formData={formData}
              setFormData={setFormData}
              handleOnChange={handleChange}
            />
          </>
        )}
        {reportValue === Reports.INVENTORY_REPORT && (
          <>
            <InventoryFilterForm
              formData={formData}
              handleOnChange={handleChange}
              setFormData={setFormData}
              item={item}
            />
          </>
        )}
        {reportValue === Reports.PROFITLOSS_REPORT && (
          <>
            <ProfitLossReportFilterForm />
          </>
        )}
        <div className="flex 280:flex-col 360:flex-row md:flex-row xmd:gap-[24px] xsmd:gap-[24px] lg:gap-[16px] justify-between pt-[20px] xl:pt-[20px]">
          <div className="320:w-full 375:w-[151px] md:w-[276px] lg:w-[250px]">
            <label>{t("report.startDate")}</label>
            <InputComponent
              type="date"
              className="320:w-full 375:w-[161px] md:w-[240px] lg:w-[240px] rounded-[4px] border-1 !border-[#D0D5DD] h-[48px] placeholder:text-[#A4A4A4]"
              placeholder="Start Date"
              value={formData.startDate}
              name="startDate"
              handleChange={handleChange}
              restrictFutureDates={true}
            />
          </div>

          <div className="320:w-full 375:w-[151px] md:w-[276px] lg:w-[250px]">
            <label>{t("report.endDate")}</label>
            <InputComponent
              type="date"
              className="320:w-full 375:w-[161px] md:w-[240px] lg:w-[240px] rounded-[4px] border-1 h-[48px] !border-[#D0D5DD] placeholder:text-[#A4A4A4]"
              placeholder="End Date"
              value={formData.endDate}
              name="endDate"
              handleChange={handleChange}
              restrictFutureDates={true}
            />
          </div>
        </div>

        {serviceName && (
              <div className="flex items-start md:items-center font-medium text-[12px] mt-[10px] gap-1">
                <div>
                  <Tooltip color={"#044E97"} />
                </div>
                <p className="">{`${serviceName} available till ${yesterdayDate}`}</p>
                {/* <p>Customer's report till current month we are in</p> */}
              </div>
            )}
        <div className="lg:w-[500px] mt-[31px]  w-full lg:h-[48px] lg:flex lg:mt-[29px] mb-[20px] lg:mb-[27px]">
          <div className="w-full">
            <button
              className="border border-[#044E97] bg-[#044E97] text-white h-[48px] px-[2em] w-full  rounded-md"
              onClick={handleSubmitPDF}
              disabled={isLoadingPDF}
            >
              {isLoadingPDF ? "Downloading..." : "Generate Report as PDF"}
            </button>
          </div>
        </div>
        <div className="mt-[]  lg:h-[48px] lg:flex lg:mt-[29px] mb-[20px] lg:mb-[27px]">
          <div className="w-full">
            <button
              className="border border-[#044E97] text-[#044E97] h-[48px] px-[2em] w-full rounded-md"
              onClick={handleSubmitCSV}
              disabled={isLoadingCSV}
            >
              {isLoadingCSV ? "Downloading..." : "Generate Report as CSV"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ReportForm;
